import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, ArrowLeft, RefreshCw } from "lucide-react";
import { useContractorContext } from "../context/ContractorContext";

interface ContractorAlertProps {
  title: string;
  message: string;
}

export default function ContractorAlert({
  title,
  message,
}: ContractorAlertProps) {
  const { t } = useTranslation();
  const { clearError, refreshContractor, errorState } = useContractorContext();

  const handleBack = () => {
    clearError();
  };

  const handleRefresh = () => {
    refreshContractor();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="text-center">
            <AlertCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-2">{t(title)}</h2>
            <p className="text-gray-600 mb-6">{t(message)}</p>
            {errorState.isQuery ? (
              <Button
                onClick={handleRefresh}
                variant="outline"
                className="w-full"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                {t("common.refresh")}
              </Button>
            ) : (
              <Button onClick={handleBack} variant="outline" className="w-full">
                <ArrowLeft className="h-4 w-4 mr-2" />
                {t("common.back")}
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
